import { render } from "./ObjectLogsWindow.vue?vue&type=template&id=11c24440&scoped=true&ts=true"
import script from "./ObjectLogsWindow.vue?vue&type=script&lang=ts"
export * from "./ObjectLogsWindow.vue?vue&type=script&lang=ts"

import "./ObjectLogsWindow.vue?vue&type=style&index=0&id=11c24440&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c24440"]])

export default __exports__